import React from 'react';

type Props = {
  positive?: boolean;
  size?: number;
  className?: string;
};

/** 에듀코디 GemIcon과 동일한 별 아이콘 */
const GemStarIcon: React.FC<Props> = ({ positive = true, size = 16, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
  >
    <path
      d="M12 2L15.09 8.26L22 9L17 14L18.18 21L12 17.77L5.82 21L7 14L2 9L8.91 8.26L12 2Z"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinejoin="round"
      fill={positive ? '#dc3545' : '#6c757d'}
    />
  </svg>
);

export default GemStarIcon;
